<template>
    <div class="modal-window uts025">
        <header class="modal-header">
            <div class="tit">{{ $i18nUtil.trans("title.RegistCategoryModal.003","카테고리 추가") }}</div>
            <button @click="closePopup" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content" >
            <div class="top" v-if="modalInfo.name == 'registShareInfoCategory'">
                <div class="dropdown ty1 relative only">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">{{docGradeName}}</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="scroll">
                                <div class="dropdown-list-item"><div class="tit"><button type="button" class="active ell-singleline" @click="changeDocGrade()" >{{ $i18nUtil.trans("message.RegistCategoryModal.001","공개여부 선택") }}</button></div></div>
                                <div class="dropdown-list-item"><div class="tit"><button type="button" class="ell-singleline" @click="changeDocGrade('NORMAL')">{{ $i18nUtil.trans("entity.category.docGrade.NORMAL","전체공개") }}</button></div></div>
                                <div class="dropdown-list-item"><div class="tit"><button type="button" class="ell-singleline" @click="changeDocGrade('SECRET')">{{ $i18nUtil.trans("entity.category.docGrade.RESTRICT","멤버만 공개") }}</button></div></div>
                            </div>
                        </div>
                    </v-menu>
                </div>
                <div class="clear">
                    <div class="ref">{{ $i18nUtil.trans("message.RegistCategoryModal.002","＊카테고리 공개여부는 생성 이후 변경할 수 없습니다.") }}</div>
                    <div class="ref" v-show="checkedDocGradeNormal">{{ $i18nUtil.trans("message.RegistCategoryModal.003","＊전체공개로 설정 시 멤버만 공개로 변경할 수 없습니다.") }}</div>
                    <div class="ref" v-show="checkedDocGradeSecret">{{ $i18nUtil.trans("message.RegistCategoryModal.004","＊멤버만 공개로 설정 시 카테고리 멤버를 구성할 수 있습니다.단, 설정 이후 전체공개로 변경할 수 없습니다.") }}</div>
                </div>
            </div> 
            <form action="" onsubmit="return false;">
                <div class="input-box">
                    <input type="text" required 
                        :placeholder="$i18nUtil.trans('UB015')" 
                        @focus="$event.target.placeholder=''"
                        @focusout="$event.target.placeholder=$i18nUtil.trans('UB015')"
                        v-model="categoryName" @input="displayBytes(maxBytes, categoryName, $event)"
                        @keyup.enter="callModalsContainer">
                    <button type="button" class="input-txt-del" @click="categoryName ='', error=false, checkBytes=0">입력 삭제</button>
                    <div class="error" v-if="error">{{ $i18nUtil.trans("message.RegistCategoryModal.005","입력 가능한 글자수를 초과하였습니다.") }} <span>({{checkBytes + `/` + maxBytes + `bytes`}})</span></div>
                    <div class="error" v-if="errorCategorydName" >{{$i18nUtil.trans('UB015')}}</div>
                </div> 
            </form>
        </div> 

        <footer class="modal-footer">
            <button type="button" class="btn_ty1" @click="callModalsContainer">{{ $i18nUtil.trans("button.RegistCategoryModal.save","등록") }}</button>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
export default {
     props: {
        modalInfo: {
        type: Object,
        required: true,
        },
    },
    components: {
    },
    created(){
        let body = document.querySelector("body");

        body.style.overflow = "hidden";
    },
    data() {
        return { 
            error: false, 
            checkBytes: 0,
            maxBytes: this.modalInfo.name == "registShareInfoCategory" ?  150 : 24, 
            errorCategorydName:false,

            categoryName : "",
            docGradeName : this.$i18nUtil.trans("message.RegistCategoryModal.001","공개여부 선택"),
            docGrade:null,

            checkedDocGradeNormal:false,
            checkedDocGradeSecret:false,
        };
    },
    methods: { 
        ...mapActions("modals", ["showDialog", "showToast", "showModal"]),
        callModalsContainer(){ 
            if(this.error){
                return;
            }
            if(this.categoryName == null || this.categoryName == undefined || this.categoryName.length == 0) {
                this.errorCategorydName = true;
                return;
            } else {
                this.errorCategorydName = false;
            } 
            
            if(this.modalInfo.name =="registShareInfoCategory" && (this.docGrade == null || this.docGrade == undefined)){
                // alert("공개여부를 선택하세요.");
                const dialogInfo = { 
                    obj: this.$modal,
                    component: Dialog,
                    title : this.$i18nUtil.trans("title.dialog.notice","알림"),
                    button : this.$i18nUtil.trans("button.dialog.confirm","확인"), 
                    contents : this.$i18nUtil.trans("message.RegistCategoryModal.006","공개여부를 선택하세요.")
                };
                this.showDialog(dialogInfo);
                return;
            }

            let param={};
            if(this.modalInfo.name =="registShareInfoCategory"){
                //정보공유
                param ={
                    categoryName : this.categoryName,
                    docGrade : this.docGrade
                }
            }else{
                //회의협의체
                param ={
                    categoryName : this.categoryName
                }
            }
 
            this.$emit("regist_category", param);
            this.closePopup();
        },
        /* byte 체크 */
        displayBytes(byteLength, addCategoryName, _event) {
            let obj = this;
            addCategoryName = _event.target.value;
            obj.addCategoryName = addCategoryName;
            let checkBytes = obj.getByteLength(obj.addCategoryName);
            obj.checkBytes = checkBytes;
            obj.error = false;
            if(checkBytes > byteLength) {
              obj.error = true;
            }
            if(checkBytes > 0) {
              obj.errorCategorydName = false;
            }
        },
        getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
        },
        cutByteLength(s, len) {
            if (s == null || s.length == 0) {
                return 0;
            }
            var size = 0;
            var rIndex = s.length;
            for ( var i = 0; i < s.length; i++) {
                size += this.charByteSize(s.charAt(i));
                if( size == len ) {
                    rIndex = i + 1;
                    break;
                } else if( size > len ) {
                    rIndex = i;
                    break;
                }
            }
            return s.substring(0, rIndex);
        },
        charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        },  
        changeDocGrade(docGrade){ 
            this.docGrade = docGrade;
            if(docGrade == 'NORMAL'){
                this.checkedDocGradeNormal = true;
                this.checkedDocGradeSecret = false;
                this.docGradeName = this.$i18nUtil.trans("entity.category.docGrade.NORMAL","전체공개");
            }else if(docGrade == 'SECRET'){
                this.docGradeName = this.$i18nUtil.trans("entity.category.docGrade.RESTRICT","멤버만 공개");
                this.checkedDocGradeNormal = false;
                this.checkedDocGradeSecret = true;
            }else{
                this.checkedDocGradeNormal = false;
                this.checkedDocGradeSecret = false;
                this.docGradeName = this.$i18nUtil.trans("message.RegistCategoryModal.001","공개여부 선택");
            } 
        },
        closePopup(){
            let body = document.querySelector("body");
            body.style.removeProperty("overflow");
            this.$emit("close");
        }  
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/modal/RegistCategoryModal.vue